export const rfidTransactions = {
  name: 'RFID 交易 |||| RFID 交易',
  fields: {
    id: '交易編號',
    rfid_user_id: 'RFID 用戶編號',
    card_uid: '卡片 UID',
    card_alias: '卡片別名',
    amount: '金額',
    type: '類型',
    status: '狀態',
    payment_method: '付款方式',
    reference_id: '參考編號',
    description: '描述',
    balance_before: '之前餘額',
    balance_after: '之後餘額',
    metadata: '其他資料',
    created_at: '建立時間',
    updated_at: '更新時間',
    rfid_user: {
      name: '用戶名稱',
      email: '用戶電郵',
      phone: '用戶電話',
    },
  },
  types: {
    topup: '增值',
    deduction: '扣款',
    refund: '退款',
    adjustment: '調整',
  },
  statuses: {
    pending: '待處理',
    completed: '已完成',
    failed: '失敗',
    cancelled: '已取消',
  },
  paymentStatuses: {
    pending: '待處理',
    paid: '已付款',
    failed: '失敗',
    refunded: '已退款',
    all: '所有狀態',
  },
  payment_methods: {
    credit_account: '信用賬戶',
    invoice: '發票',
    vendor_billing: '供應商賬單',
    external: '外部',
  },
  filters: {
    q: '搜尋',
    card_uid: '卡片 UID',
    user_name: '用戶名稱',
    rfid_user_id: 'RFID 用戶編號',
    payment_status: '付款狀態',
    type: '交易類型',
    status: '狀態',
    from_date: '開始日期',
    to_date: '結束日期',
    min_amount: '最低金額',
    max_amount: '最高金額',
  },
  summary: {
    total_transactions: '交易總數',
    total_topups: '增值總數',
    total_deductions: '扣款總數',
  },
  sections: {
    transaction_info: '交易資訊',
    card_info: 'RFID 卡片資訊',
    user_info: '用戶資訊',
    financial_details: '財務詳情',
    additional_info: '附加資訊',
  },
  actions: {
    export: '匯出 CSV',
    refresh: '重新整理',
  },
  messages: {
    exportSuccess: '交易匯出成功',
    exportFailed: '交易匯出失敗',
  },
  labels: {
    dateTime: '日期/時間',
    user: '用戶',
    amount: '金額',
    energy: '電量 (kWh)',
    paymentMethod: '付款方式',
    paymentStatus: '付款狀態',
  },
  calculationMethods: {
    single_window: '單時段',
    multi_window_meter_based: '多時段電錶計算',
    single_window_metadata: '單時段其他資料',
    accumulated_cost: '累計費用',
    from_realtime_history: '即時歷史記錄',
    simple_calculation: '簡單計算',
  },
  show: {
    title: 'RFID 交易詳情',
    transactionInfo: '交易資訊',
    rfidUserInfo: 'RFID 用戶資訊',
    chargingSession: '充電時段',
    costBreakdown: '費用明細',
    billingInfo: '賬單資訊',
    paymentDetails: '付款詳情',
    notes: '備註',
    transactionId: '交易編號',
    invoiceNumber: '發票號碼',
    invoiceDate: '發票日期',
    dueDate: '到期日',
    paidDate: '付款日期',
    createdAt: '建立時間',
    userId: '用戶編號',
    name: '姓名',
    email: '電郵',
    phone: '電話',
    sessionId: '時段編號',
    charger: '充電器',
    site: '站點',
    startTime: '開始時間',
    endTime: '結束時間',
    duration: '時長',
    energyDelivered: '電量',
    finalCost: '最終費用',
    energyCostsByWindow: '按時段劃分的電費',
    totalEnergyCost: '總電費',
    totalIdleCost: '總閒置費',
    sessionFee: '時段費',
    timeFee: '時間費',
    finalTotal: '最終總額',
    timezone: '時區',
    calculation: '計算方式',
    calculatedAt: '計算時間',
    billingPeriod: '賬單週期',
    vendor: '供應商',
    vendorEmail: '供應商電郵',
    siteId: '站點編號',
    chargerId: '充電器編號',
    vendorId: '供應商編號',
    sessionStart: '時段開始',
    sessionEnd: '時段結束',
  },
};
